import { Loader2 } from 'lucide-react';
import React, { type ReactNode } from 'react';

import { Button } from '@/Components/shadcn/button';
import { cn } from '@/lib/utils';

export type NextStepButtonProps = Omit<React.ComponentProps<typeof Button>, 'type' | 'size' | 'variant'> & {
    loading?: boolean;
    endIcon?: ReactNode;
};

const NextStepButton = ({
    loading,
    endIcon,
    children,
    className,
    disabled,
    ...props
}: NextStepButtonProps): React.JSX.Element => {
    return (
        <Button
            type="submit"
            size="default"
            variant="default"
            disabled={disabled || loading}
            className={cn('gap-2', className)}
            {...props}
        >
            {loading ? <Loader2 className="size-4 shrink-0 animate-spin" aria-hidden /> : null}
            {children}
            {endIcon ? <span className="inline-flex shrink-0">{endIcon}</span> : null}
        </Button>
    );
};

export default NextStepButton;
